export var ariaSortOrders = ['none', 'ascending', 'descending'];
